import { gql } from '@apollo/client';
import { useQuery } from '@apollo/client/react';

import PageContainer from '../../core/components/PageContainer';
import { usePropertyId } from '../../core/hooks/usePropertyId';
import PropertySelectionDialog from '../../property/components/PropertySelectionDialog';
import './Balance.scss';

const Balance = () => {
    const propertyId = usePropertyId();
    const pathname = window.location.hash.replace('#', '');

    const isLegacyRoute = pathname === '/balance';
    const isPropertyRoute = /^\/\d+\/balance/.test(pathname);

    const year = 2022;

    if (!propertyId) {
        if (isPropertyRoute) {
            return null;
        }
        if (isLegacyRoute) {
            return <PropertySelectionDialog open={true} targetPath="/balance" />;
        }
        return null;
    }

    const { data, error, loading } = useQuery<{
        balance: {
            vat: number;
            touristTax: number;
            tourismTax: number;
        };
    }>(
        gql`
            query balance($year: Int) {
                balance(year: $year) {
                    vat
                    touristTax
                    tourismTax
                }
            }
        `,
        {
            variables: {
                year,
            },
        }
    );
    if (loading) return <p>Loading...</p>;
    if (error || !data) return <p>Error :(</p>;

    return <PageContainer><div className="balance"></div></PageContainer>;
};

export default Balance;
